import { Button, Flex } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { HighlightText } from '~/components/shared/HighlightText'
import { Size } from '~/types/ThemeTypes'

import { useContactsListItemStyle } from './componentStyles/ContactsListItem.style'

interface ContactsListItemProps {
  name: string
  searchTerm?: string
  index: number
  extension?: string
  isSelected?: boolean
  onClick?: (index: number) => void
}

export const ContactsListItem = ({
  name,
  searchTerm,
  index,
  extension,
  isSelected,
  onClick,
}: ContactsListItemProps) => {
  const styles = useContactsListItemStyle()
  const content = useMemo(() => {
    return (
      <>
        <HighlightText
          noOfLines={1}
          sx={styles.text}
          query={[searchTerm ?? '']}
        >
          {name}
        </HighlightText>
        {extension && (
          <ExtensionBadge
            size={Size.md}
            extension={extension}
            searchTerm={searchTerm}
          />
        )}
      </>
    )
  }, [name, extension])

  return (
    <Flex
      key={index}
      as={Button}
      isActive={isSelected}
      sx={styles.container}
      onClick={() => onClick?.(index)}
    >
      {content}
    </Flex>
  )
}
